import { BillStatus } from "../../../types/bill";
import { StatusFilter } from "../../../types/statusFilter";
import { createStatusFilterSchema } from "../../status-filter.schema";

export const BillStatusFilterSchema = createStatusFilterSchema(BillStatus);

export type BillStatusFilter = StatusFilter<BillStatus>;
